var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.7846 18.7774L15.108 14.0991C16.3718 12.6063 17.1429 10.6779 17.1429 8.57088C17.1429 3.84261 13.3016 0 8.57501 0C3.8484 0 0 3.84261 0 8.57088C0 13.2992 3.84126 17.1418 8.56787 17.1418C10.6741 17.1418 12.6019 16.3775 14.0941 15.1062L18.7708 19.7845C19.4277 20.4416 20.4558 19.4488 19.7775 18.7774H19.7846ZM1.42798 8.57088C1.42798 4.63542 4.63379 1.42848 8.56787 1.42848C12.502 1.42848 15.7078 4.63542 15.7078 8.57088C15.7078 12.5063 12.502 15.7133 8.56787 15.7133C4.63379 15.7133 1.42798 12.5063 1.42798 8.57088Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchf);
export default __webpack_public_path__ + "static/media/Searchf.ab282f207b21aaf8d2cadb10fbe8d562.svg";
export { ForwardRef as ReactComponent };